import styled from 'styled-components';
import { ASSETS } from '../../../../../../../assets';

export const WidgetIcon = styled(ASSETS.HOURGLASS_TOP)`
  width: 11px;
  height: 16px;
  transform: rotate(180deg);
`;
